export * from "./product";
export * from "./story";
export * from "./post";

export enum Network {
  Instagram = "instagram",
  TikTok = "tiktok",
  Facebook = "facebook",
  Snapchat = "snapchat",
  WhatsApp = "whatsapp",
}

export interface Metrics {
  impressions?: number;
  reach?: number;
  reactions?: number;
  comments?: number;
  shares?: number;
  postClicks?: number;
  outboundClicks?: number;
  saved?: number;
  interactions?: number;
  video?: {
    length: number;
    avgTimeWatched: number;
    plays: number;
    thruPlays: number;
    thruPlays6s: number;
    retentionGraph?: Record<number, number>;
  };
}
